import PropTypes from "prop-types";
import React from "react";
import DataGrid, { DataGridItem } from "components/data-grid";
import { injectIntl, FormattedMessage } from "react-intl";
import { PageSection } from "components/page";
import { ExternalLink } from "components/link";
import { TextDisplay } from "components/display-data";
import ScreenPosition from "components/screen-position";
import { useAuthDataContext } from "components/auth";
import { getImgPathAsset, getImgPathCustomerAsset } from "config/paths";
import Chip from "components/chip";

const GraphicSetLayoutData = ({ layout, intl }) => {
  const { token } = useAuthDataContext();
  const imgPath =
    layout.asset && layout.asset.customerId
      ? getImgPathCustomerAsset(layout.asset, token)
      : getImgPathAsset(layout.asset, token);

  return !layout ? null : (
    <PageSection spaced>
      <DataGrid>
        <DataGridItem>
          <TextDisplay showIfEmpty label={intl.formatMessage({ id: "graphicset.layout.asset.codename" })}>
            {layout.asset && layout.asset.codename}
          </TextDisplay>
        </DataGridItem>
        <DataGridItem>
          <TextDisplay showIfEmpty label={intl.formatMessage({ id: "graphicset.layout.sendTo" })}>
            {layout.sendTo && <FormattedMessage id={`graphicset.layout.sendTo.in.${layout.sendTo.toLowerCase()}`} />}
          </TextDisplay>
        </DataGridItem>
        {["png", "apng"].includes(layout.asset.format) && (
          <>
            <DataGridItem>
              <TextDisplay showIfEmpty label={intl.formatMessage({ id: "graphicset.layout.pos" })}>
                {layout.pos && `${layout.pos.x || 0}x ${layout.pos.y || 0}y`}
              </TextDisplay>
            </DataGridItem>
            <DataGridItem>
              <TextDisplay showIfEmpty label={intl.formatMessage({ id: "graphicset.layout.size" })}>
                {layout.size && `${layout.size.x || 0}x ${layout.size.y || 0}y`}
              </TextDisplay>
            </DataGridItem>
          </>
        )}
        {layout.asset.categories && layout.asset.categories.length > 0 && (
          <DataGridItem big>
            <TextDisplay label={intl.formatMessage({ id: "asset.categories" })}>
              {layout.asset.categories.map(category => (
                <Chip key={category.id} label={category.name} />
              ))}
            </TextDisplay>
          </DataGridItem>
        )}
        {layout.segments &&
          layout.segments.map(
            (scheduleMap, index) =>
              scheduleMap &&
              scheduleMap.length > 0 && (
                <DataGrid big key={index}>
                  <DataGridItem>
                    <TextDisplay showIfEmpty label={intl.formatMessage({ id: "graphicset.layout.schedule.type" })}>
                      {scheduleMap[0].type}
                    </TextDisplay>
                  </DataGridItem>
                  {scheduleMap.map((schedule, index) => (
                    <DataGridItem big key={index}>
                      <DataGridItem>
                        <TextDisplay showIfEmpty label={intl.formatMessage({ id: "graphicset.layout.schedule.start" })}>
                          {schedule.start}
                        </TextDisplay>
                      </DataGridItem>
                      <DataGridItem>
                        <TextDisplay showIfEmpty label={intl.formatMessage({ id: "graphicset.layout.schedule.end" })}>
                          {schedule.end}
                        </TextDisplay>
                      </DataGridItem>
                    </DataGridItem>
                  ))}
                </DataGrid>
              ),
          )}

        <DataGridItem>
          {layout.asset && (
            <ExternalLink href={imgPath}>
              <FormattedMessage id="graphicset.layout.asset.path" />
            </ExternalLink>
          )}
        </DataGridItem>
        <DataGridItem>
          <ScreenPosition layouts={[layout]} />
        </DataGridItem>
      </DataGrid>
    </PageSection>
  );
};

GraphicSetLayoutData.propTypes = {
  /**
   * Data to represent
   **/
  layout: PropTypes.object,
};

export default injectIntl(GraphicSetLayoutData);
